

(function(){
    angular.module('app.widgets')
        .service("obtGalleryService", galleryService)
        .directive('viewGallery', viewGallery);
/*@ngInject*/
    function viewGallery(obtGalleryService,sessionServices){

        return {
            restrict: 'EA',
            scope:{
                data:'=?',
                galleryId:'=?',
                gallery:'=?'
            },
            link:function(scope){
              var args = {uId:sessionServices.getSession().uId , galleryId :scope.galleryId};
              obtGalleryService.getItems(args).
               then(function (response){
                 console.log(response);
                 scope.gallery = response ;
                 scope.tampon = response [0] || { };
               })

            },
            controller:viewGalleryPageSectionCtrl,
            template:'<table class="table col-md-12" border="0"><tr>'+
            '<td  style="padding-top:30%" class="col-md-1"><button   ng-if="current !== 0 " type="button" ng-click="moveLeft()" class="btn btn-default btn-xs"><span class="glyphicon glyphicon-circle-arrow-left" aria-hidden="true"></span></button></td>'+
            '<td class="col-md-10 text-center"><div class="col-md-12"><div class="thumbnail"><img ng-src="{{tampon.url}}" alt=""><div class="caption"> <h4><input  type="text" class="text-center" ng-model="tampon.details[getKey(tampon.details)].name" style="width:100%"></h4><textarea ui-tinymce="tinymceOptions" ng-model="tampon.details[getKey(tampon.details)].description"></textarea>'+
            '<p> <div  class="btn btn-primary btn-xs btn-upload"  accept="image/*"   upload-button url="./php/simpleUpload.php" on-success="onUploadSuccess(response)">'+
            '<i class="fa fa-upload" aria-hidden="true"></i> {{\'UPLOAD\'|translate}}</div><a href class="btn btn-primary btn-xs" role="button" ng-click="updateGallery()" ><i class="fa fa-plus" aria-hidden="true"></i>{{\'UPDATE\'|translate}}</a><a href class="btn btn-danger btn-xs" role="button"><i class="fa fa-trash" aria-hidden="true"></i>{{\'DELETE\'|translate}}</a></p>'+
            '</div></div>'+
            '</div></td>'+
            '<td style="padding-top:30%" class="col-md-1"><button   ng-if="current !== data.length - 1" ng-click="moveRight()" type="button" class="btn btn-default btn-xs"><span class="glyphicon glyphicon-circle-arrow-right" aria-hidden="true"></span></button></td>'+
            '</tr></table>'
        };


    }
    /*@ngInject*/
    function viewGalleryPageSectionCtrl($scope,sessionServices,obtGalleryService,queryservice,dataservice){

        loadComboBox()
        .then(setOptions)
        .then(setLanguage);
        $scope.options = [];
        $scope.languageKey = {} ;
        $scope.tmp = $scope.gallery ;
        $scope.updateGallery = updateGallery ;
      //  $scope.getKeyDetailsByLocaleId = getKeyDetailsByLocaleId ;
        $scope.onUploadSuccess = onUploadSuccess;
        $scope.current = 0 ;
        $scope.moveRight = moveRight;
        $scope.moveLeft = moveLeft;
        function updateGallery(){
          console.log($scope.tampon,'my tampon');
          console.log($scope.current);
         obtGalleryService.updateItem($scope.tampon)
         .then(function (response){
           console.log(response);
         })
        }
        function onUploadSuccess (response){
                  //  console.log(response,tampon);
                $scope.tampon.url = response.data.path;
                }





        $scope.tinymceOptions = {
             script_url: 'http://tinymce.moxiecode.com/js/tinymce/jscripts/tiny_mce/tiny_mce.js'
           };
        function moveRight(){
            $scope.current =   $scope.current + 1 ;
              $scope.tampon = $scope.gallery[$scope.current];

        }
        function moveLeft(){
          $scope.current =   $scope.current - 1 ;
          $scope.tampon = $scope.gallery[$scope.current];

        }
        $scope.getKey = function (details){
          var CurrentKey = 0;
                  angular.forEach(details,function(value,key){
                        if(value.localeId === $scope.languageKey){
                               CurrentKey = key ;
                             }
                             })
                    return CurrentKey ;
        }
        function setOptions(options){
            $scope.options = options;
            return options ;
        }
        function setLanguage(options){
              $scope.languageKey = dataservice.form.findOptionNamePerCODE(sessionServices.getSession().language,options.languages);
        }
        function loadComboBox(params) {
            var cbIdList = params || [
                    {'id': 7, 'name': 'languages'}
                ];
            return queryservice.getFormOptions(cbIdList, undefined, undefined, {isTool: true}).then(
                function success(result) {
                    return result;
                }
              )
        }
    }

    function galleryService (queryservice ) {
      function getItems(args){
          args = args || {};
          console.log('service',args);
          queryservice.setEvnArgs(args);

          return queryservice.callServer("obtDbGalleriesHelper.getGallery", args, null);
      }

      function addItem (data){
          var args = data;
          console.log(args);
          queryservice.setEvnArgs(args);
          return queryservice.callServer("obtDbGalleriesHelper.addGallery", args, null);
      }

      function updateItem (data){
          var args = data;
          queryservice.setEvnArgs(args, undefined, args.id);
          return queryservice.callServer("obtDbGalleriesHelper.updateGallery", args, null);
      }
      function updateGalleryOrder (data){

          var args= {};
          args.newOrder = data;
          console.log(args);
          //var args = data;
          queryservice.setEvnArgs(args);
          return queryservice.callServer("obtDbGalleriesHelper.updateGalleryOrder", args, null);
      }

      function deleteItem (key){
          var args={} ;
          args.galleryId = key;
          console.log('deleteItem',key);
          queryservice.setEvnArgs( args );

          return queryservice.callServer("obtDbGalleriesHelper.removeGallery", args, null);
      }

      function deleteGalleryItem (keyItem , keyGalleryItem){
          //console.log('deleteGalleryItem',keyItem , keyGalleryItem);
          //data.id,data.galleryItemId
          var args = {};
          args.id  = keyItem ;
          args.galleryItemId = keyGalleryItem
          queryservice.setEvnArgs(args);

          return queryservice.callServer("obtDbGalleriesHelper.removeGalleryItem", args, null);
      }
      function renameGallery(data){
          var args = data;
          queryservice.setEvnArgs(args);

          return queryservice.callServer("obtDbGalleriesHelper.renameGallery", args, null);
      }

      // Return the public API.
      return {
          getItems : getItems,
          updateItem : updateItem,
          addItem : addItem,
          renameGallery : renameGallery,
          deleteGalleryItem:deleteGalleryItem,
          updateGalleryOrder:updateGalleryOrder,
          deleteItem:deleteItem
      };
  }

})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/viewGalleryDirective/viewGaller.directive.js
 ** module id = 198
 ** module chunks = 0
 **/